import { PerfectiveVerb } from '../../types'

const ёбнуть: PerfectiveVerb = {
  type: 'perfective verb',
  infinitive: 'ёбнуть',
  imperativePluralSecondPerson: 'ёбните',
  imperativeSingularSecondPerson: 'ёбни',
  indicativeFuturePluralFirstPerson: 'ёбнем',
  indicativeFuturePluralSecondPerson: 'ёбнете',
  indicativeFuturePluralThirdPerson: 'ёбнут',
  indicativeFutureSingularFirstPerson: 'ёбну',
  indicativeFutureSingularSecondPerson: 'ёбнешь',
  indicativeFutureSingularThirdPerson: 'ёбнет',
  indicativePastPlural: 'ёбнули',
  indicativePastSingularFeminine: 'ёбнула',
  indicativePastSingularMasculine: 'ёбнул',
  indicativePastSingularNeuter: 'ёбнуло',
}

export default ёбнуть
